// extracted by mini-css-extract-plugin
export default {"FeaturedLink":"index_FeaturedLink__14Nxy","heading":"index_heading__2OTiD","paragraph":"index_paragraph__3b7am"};